require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-5-things-you-need-to-know-if-you-are-a-designer.json") })
        }
      }, "path---news-5-things-you-need-to-know-if-you-are-a-designer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-5-things-you-need-to-know-if-you-are-a-designer!./.cache/json/news-5-things-you-need-to-know-if-you-are-a-designer.json
// module id = 1415
// module chunks = 231608221292675